import React from "react";

const StockIcon = (props) => {
    const {size,style,color} = props;
    return(
        <svg 
            xmlns="http://www.w3.org/2000/svg"  
            viewBox="0 0 121.48 122.88" 
            width={size} 
            height={size}
            style={style}
            fill={color}
        >
            <path 
                d="M2.74,19.11L59.65,0.16c0.68-0.23,1.39-0.21,2.02,0.01l0-0.01l57.66,19.75c1.42,0.48,2.28,1.86,2.15,3.29 c0.01,0.07,0.01,0.15,0.01,0.23v67.06h-0.01c0,1.16-0.64,2.28-1.75,2.84l-57.25,29.09c-0.48,0.29-1.05,0.46-1.65,0.46 c-0.64,0-1.23-0.19-1.73-0.51L1.72,92.44c-1.08-0.57-1.71-1.67-1.71-2.82H0V22.27C0,20.66,1.19,19.33,2.74,19.11L2.74,19.11z M15.33,68.24c0-1.22,0.99-2.22,2.22-2.22c1.22,0,2.22,0.99,2.22,2.22v9.03c0,0.07,0,0.15-0.01,0.22c0,0.31,0.04,0.56,0.11,0.75 c0.03,0.06,0.06,0.12,0.12,0.16l5.53,2.57c1.11,0.51,1.59,1.83,1.08,2.93c-0.51,1.11-1.82,1.59-2.93,1.08l-5.66-2.63 c-0.1-0.04-0.2-0.09-0.3-0.16c-0.91-0.57-1.54-1.34-1.93-2.29c-0.31-0.76-0.45-1.6-0.44-2.5l0-0.14V68.24L15.33,68.24z M57.64,114.44V50.3L6.38,27.06V87.7L57.64,114.44L57.64,114.44z M115.1,27.82L64.02,50.33v64.17l51.08-25.96V27.82L115.1,27.82z M60.62,6.53L12.14,22.68l48.71,22.09l48.71-21.47L60.62,6.53L60.62,6.53z"
            />    
        </svg>
    )
}

export default StockIcon;

